import { useRef } from 'react';
import Icon from '../../../assets/icons/Icon';
import { useDict } from '../../../contexts/LanguageContext';
import { getBase64 } from '../../../utils/helper';

const InvestProofInput = (props) => {
  const {
    input, meta, outputBase64 = false, 'data-cy': dataCy, className,
  } = props;

  const dict = useDict();

  const inputRef = useRef(null);

  const onFileChange = async (e) => {
    const inputFile = e.target.files;
    const targetFile = inputFile[0];
    if (targetFile) {
      if (outputBase64) {
        const base64String = await getBase64(targetFile);
        input.onChange(base64String);
      } else {
        input.onChange(targetFile);
      }
    } else {
      input.onChange(null);
    }
  };

  return (
    <div className={className}>
      <button
        className="py-4 mx-auto w-100 text-center bg-white"
        style={{
          border: '2px dashed rgba(0,0,0,0.2)',
        }}
        type="button"
        onClick={() => inputRef.current?.click()}
      >
        {input.value.name
          ? (
            <p>{input.value.name}</p>
          )
          : (
            <>
              <Icon icon="Image" width={45} color="#226ef4" />
              <p className="upload-text">{dict.clickToUpload}</p>
            </>
          )}
        <input
          ref={inputRef}
          type="file"
          name={input.name}
          onChange={onFileChange}
          style={{ display: 'none' }}
          data-cy={dataCy}
          accept="application/pdf, image/jpeg, image/png"
        />
      </button>
      {meta.error && meta.touched && (
        <span
          className="form__form-group-error"
          data-cy={`${dataCy}--error`}
        >
          {meta.error}
        </span>
      )}
    </div>
  );
};

export default InvestProofInput;
